import React from 'react';
import PropTypes from  'prop-types';
import  { withStyles } from  '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    minHeight: 400,
  },
  button: {
    marginTop: theme.spacing.unit * 2,
  },
  formControl: {
    marginLeft: theme.spacing.unit,
    minWidth: 120,
  },
  paper: {
    width: '100%',
    height: 100,
    textAlign: 'center',
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
  },
});

@inject("commonStore")
@inject("authStore")
@observer
class SideMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      age: '',
      open: false,
      anchorEl: null,
    };
  
  }
  componentDidMount() {
    const { campaign } = this.props.commonStore
    //const { include } = campaign.inclusions.povertyLevel
  //  this.setState({levels: include})
  }
  handleDrawerClose = () => {
    this.props.handleDrawerClose()
  };
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  render() {
    const { anchorEl } = this.state;
    const { classes, theme, commonStore } = this.props;
    const { credit } = commonStore.agent
    return (
      <div className={classes.root}>
      <div>
      <IconButton onClick={this.handleDrawerClose}>
        {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon/>}
      </IconButton>
      <Button
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          FL Leads
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleClose}>Profile</MenuItem>
          <MenuItem onClick={this.handleClose}>My account</MenuItem>
          <MenuItem onClick={this.handleClose}>Logout</MenuItem>
        </Menu>
      </div>
      <Divider />
      <Paper className={classes.paper}>
      <Typography variant="title" gutterBottom>
        {`$${credit} Availible`}
      </Typography>
      <Button variant="contained" color="primary" className={classes.button} onClick={() => this.props.openDialog('addCredit')}>
         Add Balance
      </Button>
      </Paper>
      </div>
    );
  }
}

SideMenu.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles, { withTheme: true })(SideMenu);

      /*<List>{mailFolderListItems}</List>
        <Divider />
    <List>{otherMailFolderListItems}</List>*/


// WEBPACK FOOTER //
// ./src/components/Leads/SideMenu.js